import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { errorBoundary, sendTelemetryErrorEvent } from '../../common/react/components/ErrorBoundary';
import {
  PredictiveModelSpace,
  PredictiveModelSpaceDispatchProps,
  PredictiveModelSpaceOwnProps,
  PredictiveModelSpaceStateProps
} from './PredictiveModelSpace';

//Connected space uses state/dispact props to construct the actual props and connect to predictie model space with Redux infra
const mapStateToProps: MapStateToProps<PredictiveModelSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state)
});

const mapDispatchToProps: MapDispatchToProps<PredictiveModelSpaceDispatchProps> = (dispatch) =>
  bindActionCreators({
    requestSpaceContents,
  }, dispatch);

const ConnectedPredictiveModelSpaceInternal: React.ComponentClass<PredictiveModelSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(PredictiveModelSpace);

export const ConnectedPredictiveModelSpace = errorBoundary<PredictiveModelSpaceOwnProps>
  (sendTelemetryErrorEvent)(ConnectedPredictiveModelSpaceInternal);
